/* MY STORE · Fila infinita (carruseles de productos y videos).
   - Compu (mouse): la fila se mueve sola con transform; se frena con el mouse encima,
     se puede arrastrar, usar flechas o el scroll horizontal del trackpad.
   - Celular/tablet (táctil): usa el desplazamiento nativo del navegador (con su inercia),
     así deslizar con el dedo es 100% fluido. El movimiento automático se pausa apenas se toca
     y vuelve solo unos segundos después. */
(function () {
  'use strict';
  if (window.MsLoop) return;
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esTactil = function () { return window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches; };

  function gapDe(track) { var cs = getComputedStyle(track); return parseFloat(cs.columnGap || cs.gap) || 0; }

  function clonar(track, originales, veces) {
    track.querySelectorAll('[data-clon]').forEach(function (c) { c.remove(); });
    for (var k = 0; k < veces; k++) {
      originales.forEach(function (o) {
        var c = o.cloneNode(true);
        c.setAttribute('data-clon', '');
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a,button,video').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
        track.appendChild(c);
      });
    }
    track.dispatchEvent(new CustomEvent('ms-loop:clonado', { bubbles: true }));
  }

  function anchoSet(track, originales) {
    var last = originales[originales.length - 1];
    return last.offsetLeft + last.offsetWidth + gapDe(track) - originales[0].offsetLeft;
  }

  /* ---------------- Modo táctil: scroll nativo ---------------- */
  function Nativo(el, track, originales, o) {
    var setW = 0, sets = 0, pos = 0, raf = 0, ultimo = 0, activo = false, visible = false;
    var tocando = false, pausaHasta = 0, ultimoScroll = 0;
    el.classList.add('ms-loop--nativo');

    function medir() {
      el.style.scrollBehavior = 'auto';
      var w0 = anchoSet(track, originales);
      if (!w0) return false;
      setW = w0;
      sets = Math.max(5, Math.ceil((el.clientWidth * 4) / setW) + 1);
      clonar(track, originales, sets - 1);
      pos = setW * Math.floor(sets / 2) + (pos ? ((pos % setW) + setW) % setW : setW * 0.25);
      el.scrollLeft = pos;
      return true;
    }
    function centrar() {
      var mid = setW * Math.floor(sets / 2);
      if (pos < setW || pos > setW * (sets - 2)) {
        pos = mid + ((pos % setW) + setW) % setW;
        el.scrollLeft = pos;
      }
    }
    function quieto(t) { return tocando || t < pausaHasta || (t - ultimoScroll) < 300; }
    function cuadro(t) {
      raf = 0;
      if (!activo || !visible || document.hidden) return;
      var dt = ultimo ? Math.min(64, t - ultimo) : 16; ultimo = t;
      if (!quieto(t)) {
        centrar();
        if (o.mover && !reducido) {
          pos -= o.dir * (o.vel * 0.8) * dt / 1000;
          el.scrollLeft = pos;
        }
      }
      raf = requestAnimationFrame(cuadro);
    }
    function seguir() { if (!raf && activo && visible && !document.hidden) { ultimo = 0; raf = requestAnimationFrame(cuadro); } }

    el.addEventListener('touchstart', function () { tocando = true; }, { passive: true });
    el.addEventListener('touchend', function () { tocando = false; pausaHasta = performance.now() + 2500; }, { passive: true });
    el.addEventListener('touchcancel', function () { tocando = false; pausaHasta = performance.now() + 2500; }, { passive: true });
    el.addEventListener('scroll', function () {
      var real = el.scrollLeft;
      if (Math.abs(real - pos) > 1.5) { /* lo movió el cliente (o la inercia) */
        pos = real; ultimoScroll = performance.now();
        pausaHasta = Math.max(pausaHasta, ultimoScroll + 1800);
      }
    }, { passive: true });
    el.addEventListener('focusin', function () { pausaHasta = performance.now() + 4000; });

    var rw = window.innerWidth;
    window.addEventListener('resize', function () { if (!activo || Math.abs(window.innerWidth - rw) < 2) return; rw = window.innerWidth; medir(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) seguir(); }, { rootMargin: '100px 0px' }).observe(el);
    else visible = true;
    document.addEventListener('visibilitychange', seguir);

    return {
      activar: function () { activo = true; if (!setW) medir(); seguir(); },
      desactivar: function () { activo = false; if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    };
  }

  /* ---------------- Modo compu: transform ---------------- */
  function Transform(el, track, originales, o) {
    var x = 0, setW = 0, activo = false, visible = false, raf = 0, ultimo = 0;
    var pausaHover = false, pausaFoco = false, pausaHasta = 0, anim = null;
    var arr = null, vel = 0, inercia = false, movio = false;

    function medir() {
      var w0 = anchoSet(track, originales);
      if (!w0) return false;
      setW = w0;
      clonar(track, originales, Math.ceil(el.clientWidth / setW) + 1);
      x = envolver(x || -setW * 0.5);
      pintar();
      return true;
    }
    function envolver(v) { while (v > 0) v -= setW; while (v <= -setW) v += setW; return v; }
    function pintar() { track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)'; }
    function quieto() { return pausaHover || pausaFoco || arr || anim || inercia || performance.now() < pausaHasta; }
    function cuadro(t) {
      raf = 0;
      if (!activo || !visible || document.hidden) return;
      var dt = ultimo ? Math.min(64, t - ultimo) : 16; ultimo = t;
      if (inercia) {
        x = envolver(x + vel * dt); vel *= Math.pow(0.94, dt / 16);
        if (Math.abs(vel) < 0.02) { inercia = false; pausaHasta = performance.now() + 1200; }
        pintar();
      } else if (anim) {
        var p = Math.min(1, (t - anim.t0) / anim.dur), e = 1 - Math.pow(1 - p, 3);
        x = envolver(anim.desde + anim.dist * e); pintar();
        if (p >= 1) { anim = null; pausaHasta = performance.now() + 2500; }
      } else if (o.mover && !reducido && !quieto()) {
        x = envolver(x + o.vel * o.dir * dt / 1000); pintar();
      }
      raf = requestAnimationFrame(cuadro);
    }
    function seguir() { if (!raf && activo && visible && !document.hidden) { ultimo = 0; raf = requestAnimationFrame(cuadro); } }

    el.addEventListener('pointerdown', function (e) {
      if (e.button > 0 || e.target.closest('[data-loop-step]')) return;
      arr = { id: e.pointerId, x0: e.clientX, y0: e.clientY, pos: x, lx: e.clientX, lt: performance.now() };
      movio = false; inercia = false; anim = null; vel = 0;
    });
    el.addEventListener('pointermove', function (e) {
      if (!arr || e.pointerId !== arr.id) return;
      var dx = e.clientX - arr.x0;
      if (!movio) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(e.clientY - arr.y0) > Math.abs(dx)) { arr = null; return; }
        movio = true; el.classList.add('is-drag');
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var ahora = performance.now();
      vel = (e.clientX - arr.lx) / Math.max(1, ahora - arr.lt);
      arr.lx = e.clientX; arr.lt = ahora;
      x = envolver(arr.pos + dx); pintar();
    });
    function soltar(e) {
      if (!arr || (e && e.pointerId !== arr.id)) return;
      var fue = movio;
      arr = null; el.classList.remove('is-drag');
      if (fue && e && e.type === 'pointerup' && Math.abs(vel) > 0.05) { inercia = true; vel = Math.max(-3, Math.min(3, vel)); }
      else pausaHasta = performance.now() + 1500;
      seguir();
    }
    el.addEventListener('pointerup', soltar);
    el.addEventListener('pointercancel', soltar);
    el.addEventListener('lostpointercapture', soltar);
    el.addEventListener('click', function (e) { if (movio) { e.preventDefault(); e.stopPropagation(); movio = false; } }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('wheel', function (e) {
      var dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
      if (!dx) return;
      e.preventDefault();
      inercia = false; anim = null;
      x = envolver(x - dx); pintar();
      pausaHasta = performance.now() + 1500; seguir();
    }, { passive: false });
    el.addEventListener('mouseenter', function () { pausaHover = true; });
    el.addEventListener('mouseleave', function () { pausaHover = false; pausaHasta = performance.now() + 400; });
    el.addEventListener('focusin', function (e) {
      var teclado = false;
      try { teclado = e.target.matches(':focus-visible'); } catch (err) {}
      if (!teclado) return;
      pausaFoco = true;
      var item = e.target.closest('[data-loop-item]') || e.target.closest('.ms-loop__item');
      if (item) {
        var izq = item.offsetLeft + x, der = izq + item.offsetWidth;
        if (izq < 0 || der > el.clientWidth) { x = envolver(-item.offsetLeft + (el.clientWidth - item.offsetWidth) / 2); pintar(); }
      }
    });
    el.addEventListener('focusout', function () { pausaFoco = false; });
    el.querySelectorAll('[data-loop-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var paso = (originales[0].offsetWidth + gapDe(track)) * Number(b.dataset.loopStep);
        anim = { desde: x, dist: -paso, t0: performance.now(), dur: 520 };
        seguir();
      });
    });

    var rw = window.innerWidth;
    window.addEventListener('resize', function () { if (!activo || Math.abs(window.innerWidth - rw) < 2) return; rw = window.innerWidth; medir(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) seguir(); }, { rootMargin: '100px 0px' }).observe(el);
    else visible = true;
    document.addEventListener('visibilitychange', seguir);

    return {
      activar: function () { activo = true; if (!setW) medir(); seguir(); },
      desactivar: function () { activo = false; if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    };
  }

  window.MsLoop = function (el, opciones) {
    var o = { vel: 35, dir: 1, mover: true };
    for (var k in opciones) if (Object.prototype.hasOwnProperty.call(opciones, k)) o[k] = opciones[k];
    var track = el.querySelector('[data-track]');
    var originales = track ? Array.prototype.slice.call(track.children) : [];
    if (originales.length < 2) { el.classList.add('is-static'); return { activar: function () {}, desactivar: function () {} }; }
    return esTactil() ? Nativo(el, track, originales, o) : Transform(el, track, originales, o);
  };
})();
